import { createContext } from 'react';
export var SaveContext = createContext(undefined);
//# sourceMappingURL=SaveContext.js.map